import React from 'react'
import { FormattedMessage } from 'react-intl'
import { useNavigate } from 'react-router-dom'
import dayjs from 'dayjs'
import useBlockList from '../../hooks/queries/useBlockList'
import useHistoryList from '../../hooks/queries/useHistoryList'
import MainContentDiv from '../../components/templates/MainContent'
import PageLoading from '../../components/organisms/PageLoading'
import * as S from './styles'
import Search from '../Search'
import MainLineChart from '../../components/molecules/MainLineChart'
import ErrorMessageFormat from '../../components/molecules/ErrorMessageFormat'
import ContentsTitle from '../../components/molecules/ContentsTitle'
import ContentsWrapper from '../../components/organisms/ContentsWrapper'
import Table from '../../components/molecules/Table'
import commaSeparator from '../../utils/number'
import { weiToEther } from '../../utils/dataFormat'

function Home() {
  const navigate = useNavigate()
  const {
    blockListRes = {
      totalPage: 0,
      totalBlock: 0,
      blockList: [],
    },
    isLoading: isBlocksLoading,
  } = useBlockList(1, 10)

  const { isLoading: isHistoryLoading, history = [], isError: isHistoryError, error: historyError } = useHistoryList()
  const onClickAllBlocks = () => navigate(`/blocks`)

  return (
    <MainContentDiv>
      <PageLoading loading={isHistoryLoading} />
      <S.MainContentWrapper>
        <S.MainSection>
          <S.TitleSearchWrap>
            <h1 className="animate__animated animate__bounceInLeft animate__delay-0.5s">
              <FormattedMessage id="home.title" />
            </h1>
            <h2 className="animate__animated animate__bounceInLeft animate__delay-0.5s">
              <FormattedMessage id="home.subTitle" />
            </h2>
            <S.SearchBoxWrap>
              <Search />
            </S.SearchBoxWrap>
          </S.TitleSearchWrap>
          <S.ChartMainWrap>
            <S.ChartInnerWrap>
              <h3>
                <FormattedMessage id="home.chartTitle" />
              </h3>
              {!isHistoryError && !isHistoryLoading ? (
                <MainLineChart mainChartData={history} />
              ) : (
                <S.ChartErrorWrap>
                  <ErrorMessageFormat>
                    <FormattedMessage id="error.failData" /> ({historyError?.message})
                  </ErrorMessageFormat>
                </S.ChartErrorWrap>
              )}
            </S.ChartInnerWrap>
          </S.ChartMainWrap>
        </S.MainSection>
        <ContentsTitle
          title={<FormattedMessage id="home.listTitle" />}
          button="View all blocks"
          onClick={onClickAllBlocks}
        />
        <ContentsWrapper>
          <Table
            columns={[
              { title: 'Block Height', dataIndex: '0' },
              { title: 'Timestamp', dataIndex: '1' },
              { title: 'Transactions', dataIndex: '2' },
              { title: 'Block Reward', dataIndex: '3' },
            ]}
            dataSource={blockListRes.blockList.map((block) => {
              return {
                '0': <S.TableLink to={`/block/${block.blockNumber}`}>{block.blockNumber}</S.TableLink>,
                '1': <>{dayjs.unix(Number(block.timestamp)).fromNow()} </>,
                '2': (
                  <>
                    <S.TableLink to={`/block/${block.blockNumber}/txs`}>
                      {commaSeparator(block.txCount)} txns{' '}
                    </S.TableLink>
                    in 1 secs
                  </>
                ),
                '3': (
                  <>
                    {weiToEther(block.blockReward)} {block.symbol}
                  </>
                ),
              }
            })}
            loading={isBlocksLoading}
          />
        </ContentsWrapper>
      </S.MainContentWrapper>
    </MainContentDiv>
  )
}

export default Home
